var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOnlineBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.125,
    cy: 21,
    r: 21,
    fill: "#10A7C3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0826 29.1772H11.9089C11.4068 29.1772 11 29.584 11 30.0866C11 30.5883 11.4068 30.9951 11.9089 30.9951H30.0821C30.5843 30.9951 30.9911 30.5883 30.9911 30.0866C30.9906 29.584 30.5838 29.1772 30.0826 29.1772Z",
    fill: "#10A7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0447 26.8151C12.5425 26.8151 12.1357 27.2219 12.1357 27.724C12.1357 28.2262 12.5425 28.6334 13.0447 28.6334H28.9464C29.4486 28.6334 29.8554 28.2262 29.8554 27.724C29.8554 27.2219 29.4486 26.8151 28.9464 26.8151H28.7196V18.6366H28.9464C29.1979 18.6366 29.4005 18.4332 29.4005 18.1825C29.4005 17.9319 29.1971 17.7285 28.9464 17.7285H13.0447C12.7936 17.7285 12.5906 17.9319 12.5906 18.1825C12.5906 18.4332 12.794 18.6366 13.0447 18.6366H13.2719V26.8147H13.0447V26.8151ZM26.9018 18.6366V26.8147H24.1759V18.6366H26.9018ZM22.3581 18.6366V26.8147H19.6322V18.6366H22.3581ZM15.0889 18.6366H17.8148V26.8147H15.0889V18.6366Z",
    fill: "#10A7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9089 16.9109H30.0822C30.0851 16.9109 30.0885 16.9109 30.0911 16.9109C30.5936 16.9109 31 16.5041 31 16.002C31 15.6029 30.743 15.2646 30.386 15.142L21.3692 11.0847C21.1321 10.9783 20.8611 10.9783 20.6236 11.0847L11.5362 15.1735C11.1451 15.3497 10.9302 15.7744 11.0204 16.1931C11.1102 16.6118 11.4804 16.9109 11.9089 16.9109Z",
    fill: "#10A7C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineBanking);
export default __webpack_public_path__ + "static/media/ic_online_banking.3598a610311b26981a26ba01d3cda7aa.svg";
export { ForwardRef as ReactComponent };